import $ from 'jquery';

const SELECTORS = {
  buttonContainers: '.v2-work-page-container, .v2-services-list, #work-item-more-info-modal, .v2-comparison-table, .top-level-category-modal',
  addWorkItemBtn: '.js-add-work-item-btn',
};

const EVENTS = {
  itemAdded: 'item_added',
  itemRemoved: 'item_removed',
};

const CSS_CLASSES = {
  buttonBlue: 'button-blue',
  buttonRed: 'button-red',
};

export default class WorkItemButtonManager {
  constructor(workPage) {
    this.workPage = workPage;
  }

  init() {
    this._bindButtonEvents();
    this.workPage.updateButtonStates();
  }

  _bindButtonEvents() {
    $(SELECTORS.buttonContainers)
      .on(EVENTS.itemAdded, SELECTORS.addWorkItemBtn, function () {
        var $this = $(this);
        if ($this.is('a') || $this.children('svg').length > 0) return; // skip links and non-text buttons

        $this.removeClass(CSS_CLASSES.buttonBlue).addClass(CSS_CLASSES.buttonRed);
        $this.find('span').text($this.data('added-text') || 'Remove');
      })
      .on(EVENTS.itemRemoved, SELECTORS.addWorkItemBtn, function () {
        var $this = $(this);
        if ($this.is('a') || $this.children('svg').length > 0) return; // skip links and non-text buttons

        $this.removeClass(CSS_CLASSES.buttonRed).addClass(CSS_CLASSES.buttonBlue);
        $this.find('span').text($this.data('removed-text') || 'Add');
      });
  }
}
